<template>
    <v-app id="inspire">
        <!-- Install dialog shown on IOS device -->
        <div class="text-center">
            <v-bottom-sheet v-model="prompt" persistent>
                <v-sheet class="text-center" height="200px">
                    <div class="py-3">
                        <v-btn icon>
                            <v-icon large>mdi-plus-box</v-icon>
                        </v-btn>
                        Install ClimateRX: Tap
                        <v-btn icon>
                            <v-icon>mdi-export-variant</v-icon>
                        </v-btn>
                        and then Add to Homescreen
                    </div>
                    <v-btn
                        class="mt-6"
                        text
                        color="error"
                        @click="prompt = !prompt"
                    >
                        close
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <v-banner class="banner text-left" v-if="deferredPrompt">
            <v-icon slot="icon" color="warning" size="24"> mdi-star </v-icon>
            Add ClimateRX App to your Home Screen
            <template v-slot:actions>
                <v-btn text color="white" @click="dismiss">Dismiss</v-btn>
                <v-btn text color="white" @click="install">Install</v-btn>
            </template>
        </v-banner>

        <v-snackbar v-model="flag" top color="error top-element">
            {{ message
            }}
            <v-btn color="white" text @click="flag = false">
                Close
            </v-btn
            >
        </v-snackbar >

        <!-- main template -->

        <v-layout row wrap>
            <v-flex xs12 sm6>
                <v-img src="../assets/logo-B.jpg" :aspect-ratio="1"></v-img>
                <p style="text-align:center;">Climate RX v.1.7.8.2025</p>
            </v-flex>
            <v-flex xs12 sm6 id="loginCard">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="9">
                        <v-card class="elevation-12">
                            <v-toolbar dark flat>
                                <v-toolbar-title>LOGIN</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            :href="source"
                                            icon
                                            large
                                            target="_blank"
                                            v-on="on"
                                        >
                                        </v-btn>
                                    </template>
                                    <span>Source</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <label>Email</label>
                                    <v-text-field
                                        name="email"
                                        required
                                        v-model="email"
                                        :rules="emailRules"
                                        prepend-icon="mdi-email"
                                        type="text"
                                        v-on:keyup="onEnterKey"
                                    ></v-text-field>
                                    <label>Password</label>
                                    <v-text-field
                                        id="password"
                                        required
                                        name="password"
                                        v-model="password"
                                        :rules="passwordRules"
                                        prepend-icon="mdi-lock"
                                        type="password"
                                        v-on:keyup="onEnterKey"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <router-link
                                    to="/forgot-password"
                                    class="primary--text subtitle-2 text-decoration-underline"
                                >
                                    Forgot Password?
                                </router-link>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="white--text mr-2"
                                    color="#2b3990"
                                    @click="loginUser"
                                >
                                    Login
                                    <Loader v-if="loading" />
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>

        <!-- <v-snackbar v-model="flag" top color="error">
          Can't login with that credentials!<v-btn
            color="white"
            text
            @click="
              flag = false;
              loading = false;
            "
          >
            Close</v-btn
          ></v-snackbar> -->
    </v-app>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Spinner.vue";
import Cookies from "js-cookie";

export default {
    components: { Loader },
    props: {
        source: String,
    },
    data() {
        return {
            deferredPrompt: null,
            valid: true,
            loading: false,
            flag: false,
            email: "",
            prompt: null,
            message: "",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            password: "",
            passwordRules: [(v) => !!v || "Password is required"],
        };
    },
    head: {
        meta: [{ name: "ClimateRX", content: "ClimateRX" }],
        link: [
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon.png"),
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-144x144.png"),
                sizes: "144x144",
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-152x152.png"),
                sizes: "152x152",
                type: "image/png",
            },
            {
                rel: "apple-touch-icon",
                href: require("@/assets/meta/ios/apple-touch-icon-180x180.png"),
                sizes: "180x180",
                type: "image/png",
            },
        ],
        script: [
            // { type: 'text/javascript', src: require('@/assets/test.js'), async: true, body: true},
        ],
    },
    computed: {
        permissions() {
            return this.$store.state.roles.permissions;
        },
    },
    created() {
        this.checkDevice();
        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            if (Cookies.get("add-to-home-screen") === undefined) {
                this.deferredPrompt = e;
            }
        });
        window.addEventListener("appinstalled", () => {
            this.deferredPrompt = null;
        });
    },
    methods: {
        ...mapActions({
            login: "login",
            getRoles: "roles/getUserPermissions",
        }),
        async dismiss() {
            Cookies.set("add-to-home-screen", null, { expires: 15 });
            this.deferredPrompt = null;
        },
        async install() {
            this.deferredPrompt.prompt();
        },
        validate() {
            return this.$refs.form.validate();
        },
        loginUser() {
            this.loading = true;
            if (this.validate()) {
                let user = {
                    Email: this.email,
                    Password: this.password,
                };
                this.login(user)
                    .then((res) => {
                        if (!res.data.success) {
                            this.flag = true;
                            this.loading = false;
                            this.message = res.data.msg;
                            console.log("flagged");
                            return;
                        }

                        this.getRoles();

                        const nextPath = this.$route.query.next;

                        if (nextPath) {
                            this.$router.push(decodeURI(nextPath));
                        } else {
                            if (
                                res.data.user.Role === "Direct Care Staff" ||
                                res.data.user.Role === "Shift Lead" ||
                                res.data.user.Role === "Assistant Manager" ||
                                res.data.user.Role === "House Manager" ||
                                res.data.user.Role === "Program Manager" ||
                                res.data.user.Role === "Human Resources" ||
                                res.data.user.Role ===
                                    "Client Services Manager" ||
                                res.data.user.Role === "Program Coordinator" ||
                                res.data.user.Role === "Medical Manager" ||
                                res.data.user.Role === "Executive Director" ||
                                res.data.user.Role === "Finance Manager" ||
                                res.data.user.Role === "Compliance Manager" ||
                                res.data.user.Role === "Administration" ||
                                res.data.user.Role === "SuperAdministrator"
                            ) {
                                // if (
                                //     res.data.user.VerificationStatus !==
                                //         "Verified" &&
                                //     res.data.user.Role !== "Administration" &&
                                //     res.data.user.Role !== "SuperAdministrator"
                                // ) 
                                // {
                                //     return this.$router.push({
                                //         name: "NewHirePortal",
                                //         params: { empID: res.data.user._id },
                                //     });
                                // }

                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    return this.$router.push(
                                        "/staffInfo/" + res.data.user._id,
                                        () => {}
                                    );
                                }
                            } /*else if (res.data.user.Role == "Client - Basic" ||
                            res.data.user.Role == "Client - Billing" ||
                            res.data.user.Role == "Client - Intake" ||
                            res.data.user.Role == "Client - Med/Mar" ||
                            res.data.user.Role == "Client - Service/Plan/ADLs" ||
                            res.data.user.Role == "Client - Support Strategies"
                        ) {
                            if (res.data.user.VerificationStatus != "Verified") {
                                this.$router.push({name: 'NewHirePortal', params: {empID: res.data.user._id}})
                            } else {
                                this.$router.push("/clientinfo");
                            }
                        }*/ else if (
                                res.data.user.Role === "Parent/Guardian" ||
                                res.data.user.Role === "Support Coordinator" ||
                                res.data.user.Role === "Client"
                            ) {
                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    let clientID = localStorage.getItem("clientId");
                                    if (clientID == '') clientID = localStorage.getItem("userID");

                                    this.$router.push("/clientInfo/" + clientID);
                                }
                            } else if (res.data.user.Role === "Pharmacy") {
                                if (
                                    localStorage.getItem("autoLogout") ===
                                    "auto"
                                ) {
                                    let page = localStorage.getItem("lastPage");
                                    localStorage.removeItem("autoLogout");
                                    localStorage.removeItem("lastPage");
                                    return this.$router.push(page);
                                } else {
                                    this.$router.push("/client");
                                }
                            } else {
                                this.$router.push("/");
                            }
                            //console.log("logged in");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.loading = false;
            }
        },
        onEnterKey: function (e) {
            if (e.keyCode === 13) {
                this.loginUser();
            }
        },
        checkDevice() {
            const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();
                return /iphone|ipad|ipod/.test(userAgent);
            };
            const isInStandaloneMode = () =>
                "standalone" in window.navigator && window.navigator.standalone;
            if (isIos() && !isInStandaloneMode()) {
                this.prompt = true;
            }
        },
    },
};
</script>

<style scope>
#loginCard {
    margin-top: auto;
    margin-bottom: auto;
}

@media only screen and (max-width: 480px) {
    .v-sheet.v-card {
        display: block;
    }

    #loginCard {
        margin-top: -40px;
        padding-top: 0;
        margin-right: 25px;
        margin-left: 25px;
    }

    .v-image {
        height: 100px;
        margin-top: 100px;
        margin-bottom: 0px;
    }
}

.banner {
    z-index: 9998;
}

.top-element {
    z-index: 9999;
}

.v-image {
    max-height: 100vh;
}

.v-banner__wrapper {
    background-color: #2b3990;
    color: #fff;
}
</style>
